import axios from 'axios'

const state = {
  jobPosts: null,
  jobPost: null,
  jobPostIdInterest: null, // Job Post ที่กดสนใจ แต่ยังกรอกข้อมูลโปรไฟล์ไม่ครบถ้วนให้ไปกรอกข้อมูลโปรไฟล์ตัวเองก่อน เป็นการพัก Job Post Id ไว้เอามา addData() สนใจงานหลังกรอกเสร็จ
  canLoadMore: false,
  professional: null
}

const actions = {
  fetchJobPosts: async ({ commit }, params) => {
    if (params.page === 0) {
      commit('SET_JOB_POSTS', null)
    }
    const url = '/job-posts'
    const res = await axios.get(url, { params })
    if (res.status === 200) {
      const response = res.data
      if (!response.error) {
        if (params.page === 0) {
          commit('SET_JOB_POSTS', response.job_posts)
        } else {
          commit('SET_MORE_JOB_POSTS', response.job_posts)
        }
        commit('SET_CAN_LOAD_MORE', true)
      } else {
        commit('SET_CAN_LOAD_MORE', false)
      }
    }
  },
  fetchJobPostDetail: async ({ commit }, id) => {
    return new Promise(async (resolve, reject) => {
      const url = `/job-posts/${id}`
      const res = await axios.get(url)
      if (res.status === 200) {
        const response = res.data
        commit('SET_JOB_POST', response.job_post)
        resolve(res.data)
      } else {
        reject(new Error('Error fetchJobPostDetail'))
      }
    })
  },
  fetchJobPostDetailByCode: async ({ commit }, code) => {
    const url = `/job-posts/0`
    const res = await axios.get(url, { params: { code: code } })
    if (res.status === 200) {
      const response = res.data
      commit('SET_JOB_POST', response.job_post)
    }
  }
}

const mutations = {
  SET_PROFESSIONAL: (state, professional) => {
    state.professional = professional ? { ...professional } : null
  },
  SET_JOB_POSTS: (state, jobPosts) => {
    state.jobPosts = jobPosts
  },
  SET_MORE_JOB_POSTS: (state, jobPosts) => {
    state.jobPosts = [...state.jobPosts, ...jobPosts]
  },
  SET_JOB_POST: (state, jobPost) => {
    state.jobPost = jobPost
  },
  SET_CAN_LOAD_MORE: (state, status) => {
    state.canLoadMore = status
  },
  UPDATE_JOB_POST: (state, jobPost) => {
    let isUpdated = false
    for (let key in state.jobPosts) {
      if (state.jobPosts[key].id === jobPost.id) {
        state.jobPosts[key] = { ...jobPost }
        isUpdated = true
        break
      }
    }
    if (isUpdated) {
      state.jobPosts = [...state.jobPosts]
    }
  },
  DELETE_JOB_POST: (state, jobPost) => {
    for (let key in state.jobPosts) {
      if (state.jobPosts[key].id === jobPost.id) {
        state.jobPosts.splice(key, 1)
        break
      }
    }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/job.post.js